import moment from 'moment';

export const formatTime = (value, type = 'YYYY-MM-DD hh:mm:ss') => moment(value * 1000).format(type);

export const formatTimes = (value, type) => moment(value).format(type);



// WEBPACK FOOTER //
// ./src/filters/index.js